"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ioTsRefinedInterpreter = exports.predicate = exports.refinement = void 0;
var utils_1 = require("@morphic-ts/common/lib/utils");
var function_1 = require("fp-ts/function");
var io_ts_1 = require("io-ts");
var config_1 = require("../config");
var hkt_1 = require("../hkt");
/**
 *  @since 0.0.1
 */
var refinement = function (T, ref, name) {
    return new io_ts_1.Type(name, function (x) { return T.is(x) && ref(x); }, function (i, c) {
        var r = T.decode(i);
        if (r._tag === 'Left') {
            return r;
        }
        var v = r.right;
        return ref(v) ? io_ts_1.success(v) : io_ts_1.failure(i, c);
    }, T.encode);
};
exports.refinement = refinement;
/**
 *  @since 0.0.1
 */
var predicate = function (T, predicate, name) {
    return new io_ts_1.Type(name, function (x) { return T.is(x) && predicate(x); }, function (i, c) {
        var r = T.decode(i);
        if (r._tag === 'Left') {
            return r;
        }
        var v = r.right;
        return predicate(v) ? io_ts_1.success(v) : io_ts_1.failure(i, c);
    }, T.encode);
};
exports.predicate = predicate;
/**
 *  @since 0.0.1
 */
exports.ioTsRefinedInterpreter = utils_1.memo(function () { return ({
    _F: hkt_1.IoTsURI,
    refined: function (a, ref, name, config) { return function (env) {
        return function_1.pipe(a(env).type, function (type) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(exports.refinement(type, ref, name), env, { type: type })); });
    }; },
    constrained: function (a, pred, name, config) { return function (env) {
        return function_1.pipe(a(env).type, function (type) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(exports.predicate(type, pred, name), env, { type: type })); });
    }; }
}); });
